import {
  PRODUCT_ATTRIBUTE,
  PRODUCT_CATEGORY,
  ProductCategoryConfig
} from './const'
import { ClickAction } from './report'
import { FORMATTED_PRODUCT_SERIE, PRODUCT_SERIES_LIST } from './series'
import { STACKINGS_LSIT } from './stacking'

export type StackingSet = (typeof STACKINGS_LSIT)[number] & {
  kv: string
}
export type NewWorksItemOfCategories = {
  type: 'categories'
  key: string
  hidden: boolean
  categories: ProductCategoryConfig[]
}
export type NewWorksItemWithCondition = {
  type: 'products'
  key: string
  hidden: boolean
  cover: string
  kv: string
  category: string
  title: string[]
  query: {
    categories: ProductCategoryConfig[]
    attributes: (typeof PRODUCT_ATTRIBUTE)[keyof typeof PRODUCT_ATTRIBUTE][]
  }
  actionNumber: number
}
export type NewWorksItemOfSeries = {
  type: 'series'
  key: string
  hidden: boolean
  series: FORMATTED_PRODUCT_SERIE[]
}
export type NewWorksItem =
  | StackingSet
  | NewWorksItemOfCategories
  | NewWorksItemWithCondition
  | NewWorksItemOfSeries

export default [
  ...STACKINGS_LSIT,
  {
    type: 'categories',
    key: `NEWWORKS`,
    hidden: false,
    categories: [
      PRODUCT_CATEGORY.RING,
      PRODUCT_CATEGORY.BRACELET,
      PRODUCT_CATEGORY.EARRING,
      PRODUCT_CATEGORY.WATCH
    ]
  },
  {
    type: 'products',
    key: `COCOCRUSH_RINGS`,
    hidden: false,
    cover: `COCOCRUSH_RING`,
    title: [`COCO CRUSH`],
    query: {
      categories: [PRODUCT_CATEGORY.RING],
      attributes: [PRODUCT_ATTRIBUTE.COCOCRUSH]
    },
    actionNumber: ClickAction.COCOCRUSH_RINGS
  },
  {
    type: 'products',
    key: `PREMIERE_EDITION_EDITION`,
    hidden: false,
    cover: `PREMIERE_WATCH`,
    title: [`PREMIÈRE ÉDITION`, `ORIGINALE`],
    query: {
      categories: [PRODUCT_CATEGORY.WATCH],
      attributes: [PRODUCT_ATTRIBUTE.PREMIÈRE]
    },
    actionNumber: ClickAction.PREMIERE_EDITION_ORIGINALE_WATCH
  },
  {
    type: 'products',
    key: `RIPPLE_TEST_SET`,
    hidden: true,
    query: {
      categories: [],
      attributes: [PRODUCT_ATTRIBUTE.TEST]
    }
  },
  {
    type: 'series',
    key: `WATCH`,
    hidden: false,
    series: PRODUCT_SERIES_LIST
  }
] as NewWorksItem[]
